// Import .less entry point
import '../assets/private/stylesheets/catalog/_catalog.less';
import './catalog/styles/style';

/** specific country imports */
import { init as initCountrySpecific} from '@/_override/catalog/catalog-country.entry';
import '@/_override/catalog/catalog-country.less';
/** end of specific country imports */

import './legacy/browse/paginationbutton.legacy';
import './catalog/legacy/product-details.legacy';
import './catalog/legacy/product-conversion.legacy';

import {init as initReviewsFloor} from './catalog/product-details/reviews-floor';
import {init as initAssistanceFloor} from './catalog/product-details/assistance-floor';
import {init as initProductDetails} from './catalog/product-details.entry';
import {init as initProductList} from './catalog/product-list.entry';
import {init as initWorkshop} from './workshop/workshop.entry';

// Import analytics
import { init as initAnalytics } from './analytics/routes/catalog.anly.route';

document.addEventListener('DOMContentLoaded', () => {

  // Product Reviews
  if (cube.$id('ReviewsFloor') || cube.$id('ReviewsList')) initReviewsFloor();

  // Assistance
  if (cube.$id('AssistanceFloor')) initAssistanceFloor();

  // Product Details
  if (cube.$('body.product-page')) initProductDetails();

  // Product List
  if (cube.$('.listing-page')) initProductList();

  // Workshop
  if (cube.$('body#workshop')) initWorkshop();

  initCountrySpecific();

  try {
    if ( window.cube.config.anly_useLegacy === 'Y') {
      initAnalytics();
    }
  } catch (error) {
    console.warn(`analytics was not initiated \n error: ${error}`);
  }

  if (cube.$id('sportspage'))
    import(/* webpackChunkName: "catalog-sportspage" */ './catalog/sportspage/sportspage').then( sportspage => sportspage.init() );
});



// WEBPACK FOOTER //
// ./src/catalog.route.js